/**
 * The typings for this has been hacked together to keep the same api as before typescript.
 * Used Redux Toolkit as a reference.
 * We should probably look for a different way to do this.
 */
/* eslint-disable */
import { Action, AnyAction, Reducer } from 'redux';

type Actions<T extends keyof any = string> = Record<T, Action>;

type CaseReducer<S = any, A extends Action = AnyAction> = (
	state: S,
	action: A
) => S | void;

type CaseReducers<S, AS extends Actions> = {
	[T in keyof AS]: AS[T] extends Action ? CaseReducer<S, AS[T]> : void;
};

const createReducer =
	<State, CR extends CaseReducers<State, any> = CaseReducers<State, any>>(
		initialState: State,
		caseReducers: CR,
		defaultCaseReducer?:
			| ((state: State, action: Action<any>) => State)
			| undefined
	): Reducer<State, Action<any>> =>
	(state: State = initialState, action: Action<any>): State => {
		// FIXME just check `handlers[action.type]` instead
		if (caseReducers.hasOwnProperty(action.type)) {
			// @ts-ignore
			return caseReducers[action.type](state, action);
		}

		if (defaultCaseReducer) {
			return defaultCaseReducer(state, action);
		}

		return state;
	};

export default createReducer;
